export default __webpack_public_path__ + "static/media/Maithili_af_1.c5600dce.mp3";